export default "__VITE_ASSET__162fdbcf__"